// 菜单 侧边栏
export default [
  {
    path: '/attendance',
    // title: '学生考勤统计',
    title: '考勤统计',
    // iconSvg: 'attendance',
    iconSvg: 'kaoqintongji',
    roles: ['1', '2', '5']
  },
  {
    path: '/studyAnalysis',
    title: '学生行为统计',
    iconSvg: 'learning',
    roles: ['1', '2', '5']
  },
  // {
  //   path: '/class',
  //   title: '班级管理',
  //   iconSvg: 'classroom',
  //   roles: ['2']
  // },
  // {
  //   path: '/faces',
  //   // title: '学生头像管理',
  //   title: '头像管理',
  //   iconSvg: 'face',
  //   roles: ['5']
  // },
  {
    path: '/schools',
    title: '学校管理',
    iconSvg: 'school',
    roles: ['0', '10']
  },
  {
    path: '/dataReport',
    title: '数据统计',
    iconSvg: 'dataReport',
    roles: ['0', '10']
  },
  {
    title: '系统设置',
    roles: ['0'],
    // iconSvg: 'setting',
    iconSvg: 'xitongshezhi',
    children: [
      {
        path: '/camera',
        title: '镜头管理',
        iconSvg: 'camera',
        roles: ['0']
      },
      {
        path: '/application',
        title: '应用管理',
        iconSvg: 'application',
        roles: ['0']
      },
      {
        path: '/setting',
        title: '角色分配',
        iconSvg: 'role',
        roles: ['0']
      }
    ]
  },
  {
    path: '/rest',
    title: '系统设置',
    // iconSvg: 'setting',
    iconSvg: 'xitongshezhi',
    roles: ['2', '5'],
    children: [
      // {
      //   path: '/rest',
      //   title: '系统设置',
      //   iconSvg: 'setting',
      //   roles: ['5']
      // },
      {
        path: '/attendacnePlan',
        title: '考勤计划',
        roles: ['2', '5']
      },
      {
        path: '/portrait',
        title: '头像管理',
        roles: ['2', '5']
      },
      {
        path: '/cardNumber',
        title: '卡号管理',
        roles: ['2', '5']
      }
    ]
  }
];
